import { BmobMessage } from "@/entities/bmob";
import { getBeforeNowCount, getRandomAvatar, showImg } from "@/utils/utils";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "MESSAGE",

  setup(prop, context) {
    console.log("prop", context);
    const router = useRouter();
    const stateObj = {
      messages: [],
      input: "",
      loading: false,
      finished: false
    };
    const state = reactive(stateObj);
    const form = new BmobMessage(reactive({
      name: "",
      content: "",
      files: [],
      state: false
    }));

    const toBack = () => {
      router.back();
    };

    const onLoad = async () => {
      try {
        form.page++;
        const messages = await form.findAll();
        state.loading = false;

        if (messages.length < form.size) {
          state.finished = true;
        }

        state.messages.push(...messages);
      } catch (error) {
        state.finished = true;
      }
    };

    const getMessages = async () => {
      console.log(1);

      try {
        const messages = await form.findAll();
        const init = {
          objectId: "1",
          name: "zhanzhan.wei",
          content: "Hello everyone! 欢迎大家，请适当言论，喜欢记得给个star呀！(づ￣ 3￣)づ",
          files: [require("../../assets/images/1.png"), require("../../assets/images/2.png"), require("../../assets/images/3.png"), require("../../assets/images/4.png"), require("../../assets/images/qrcode.jpg"), require("../../assets/images/5.png"), require("../../assets/images/6.png"), require("../../assets/images/7.png"), require("../../assets/images/8.png")],
          state: false
        };
        state.messages = [init, ...messages];
      } catch (error) {
        const init = {
          objectId: "1",
          name: "zhanzhan.wei",
          content: "Hello everyone! 欢迎大家，请适当言论，喜欢记得给个star呀！(づ￣ 3￣)づ",
          files: [require("../../assets/images/1.png"), require("../../assets/images/2.png"), require("../../assets/images/3.png"), require("../../assets/images/4.png"), require("../../assets/images/qrcode.jpg"), require("../../assets/images/5.png"), require("../../assets/images/6.png"), require("../../assets/images/7.png"), require("../../assets/images/8.png")],
          state: false
        };
        state.messages = [init];
      }
    }; // 留言


    const toSendMessage = () => {
      router.push("/form");
    }; // 头像


    const setAvatar = id => {
      const dom = document.getElementById(id);
      dom && getRandomAvatar(dom);
    };

    const toStar = () => {
      console.log("点赞");
    };

    const toComment = () => {
      console.log("评论");
    };

    onMounted(() => {
      getMessages();
    });
    return { ...toRefs(state),
      toBack,
      toSendMessage,
      form,
      getBeforeNowCount,
      onLoad,
      setAvatar,
      toStar,
      toComment,
      showImg
    };
  }

});